import { filter, startsWith } from 'lodash';

export function cleanRichTextHtml(selector, skipLast = false) {
    const children = document.getElementById(selector) && document.getElementById(selector).childNodes;
    if (children) {
        for (var i = 0; i < children.length; i++) {
            if (
                ((children[i].className || '').includes('ce-element--empty') &&
                    children[i].children.length === 0 &&
                    children[i].innerText.length === 0 &&
                    (skipLast
                        ? filter(children, c => {
                              return ((c && c.className) || '').includes('ce-element--empty');
                          }).length > 1
                        : true)) ||
                (children[i].tagName === 'P' && !children[i].className && !children[i].innerText.length)
            ) {
                children[i].remove();
            }
        }
    }
}

export function downloadPDF(name, base64) {
    const linkSource = `data:application/pdf;base64,${base64}`;
    const downloadLink = document.createElement('a');
    const fileName = `${name}.pdf`;
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
}

export function transformHref(link) {
    if (!startsWith(link, 'mailto:') && !startsWith(link, 'tel:') && !startsWith(link, 'http')) {
        return `https://${link}`;
    }
    return link;
}



// WEBPACK FOOTER //
// ./src/lib/html.utils.js